// Function to set cookies on the browser in the right format

export function setCookie(key, value, expiresIn, units, options = []) {
    if( key && value ) {
        let d = new Date();
        let days = 7;
        let hours = 24;
        let minutes = 60;
        let seconds = 60;
    
        switch(units){
            case 'days':
                days = expiresIn; 
                break;
            case 'hours':
                days = 0;
                hours = expiresIn; 
                break;
            case 'minutes':
                days = 0;
                hours = 0;
                minutes = expiresIn; 
                break;
            case 'seconds':
                days = 0;
                hours = 0;
                minutes = 0;
                seconds = expiresIn; 
                break;
        }
        d.setTime(d.getTime() + days * hours * minutes * seconds * 1000);
        let expires = "expires=" + d.toUTCString();

        let path = "path=/";
        if(options["path"]) path = "path=" + options["path"];
        
        document.cookie = key + "=" + encodeURIComponent(value) + ";" + expires + ";" + path + ";";
        return true;
    } else { return false }
}

export function getCookie(name) {
    if (typeof document === 'undefined') return null

    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)

    if (parts.length === 2) {
        return parts.pop().split(';').shift()
    }

    return null
}

export function deleteCookie(key) {
    if (!key) return false;

    let path = "/";
    document.cookie = encodeURIComponent(key) + "=;" + "expires=Thu, 01 Jan 1970 00:00:00 GMT;" + "path=" + path + ";";
    return true;
}
